/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../widgets/livewidget/nls/StringResources'
], function(APIFactory, PropertiesProviderAPI, StringResources) {


	class CanvasExtensionPropertyProvider {

		static PROP_ID_SHOW_DATA_GRID_IN_CONSUME = 'showDataGridInConsumeMode';
		constructor( { features,spec }) {
			this._properties = features.Properties;
			this.dashboard = features.API;
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			// register self as a 'Properties' provider
			this._properties.registerProvider(this._api);
			this.featureChecker = this.dashboard && this.dashboard.getGlassCoreSvc('.FeatureChecker');
			this.featureModel = spec || {};
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			if (this._properties) {
				this._properties.deregisterProvider(this._api);
			}
		}

		getPropertyLayoutList() {
			const sectionId = this.featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled') ? 'advanced' : 'general.advanced';
			return [{
				id: CanvasExtensionPropertyProvider.PROP_ID_SHOW_DATA_GRID_IN_CONSUME, //must correspond to id in getPropertyList
				editor: {
					sectionId: sectionId,
					position: 1,
					uiControl: {
						type: 'ToggleButton',
						label: StringResources.get('propshowDataGridInConsumeMode')
					},
					validatePropertyValue: (value) => {
						return {
							isValid: typeof value === 'boolean',
							message: 'showDataGridInConsumeMode property must be of type boolean.'
						};
					}
				},
				supportsUndoRedo: true
			}];
		}

		getPropertyList() {
			return [
				{
					id: CanvasExtensionPropertyProvider.PROP_ID_SHOW_DATA_GRID_IN_CONSUME,
					setPropertyValue: (value) => {
						this.featureModel.showDataGridInConsumeMode = value;
					},
					getPropertyValue: () => {
						return this.featureModel.showDataGridInConsumeMode;
					},
					supportsUndoRedo: true
				}];
		}

		//Needed to serialize the featureModel into its spec.
		toJSON() {
			return this.featureModel;
		}

		reset() { }


	}

	return CanvasExtensionPropertyProvider;
});
